import toast from "react-hot-toast";
import { FR_SDK_FACE_API, FR_SDK_KYC_API } from "constants/index";

declare global {
  interface Window {
    jukshioFaceCapture?: (
      params: any,
      callback: (response: any) => void,
    ) => void;
  }
}

const loadScript = (src: string) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });

export const loadFaceCaptureScripts = async () => {
  try {
    await loadScript(FR_SDK_FACE_API);
    await loadScript(FR_SDK_KYC_API);
  } catch (error) {
    console.error("Failed to load face capture scripts", error);
    toast.error("Failed to load face capture system");
  }
};

export const captureFace = async (): Promise<any> => {
  if (!window.jukshioFaceCapture) {
    const error = new Error("Face capture system not ready. Please try again.");
    toast.error(error.message);
    throw error;
  }

  return new Promise((resolve, reject) => {
    window.jukshioFaceCapture?.({}, (response: any) => {
      if (
        !response ||
        (!response.image &&
          !response.imageResized224 &&
          !response.imageResized450)
      ) {
        reject(new Error("No image captured"));
        return;
      }

      resolve({
        ...response,
        image: response.image,
        image1: response.imageResized224,
        image2: response.imageResized450,
      });
    });
  });
};
